"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../..");
const store_1 = require("../../store");
const TextInput_1 = require("./components/text/TextInput");
const YesNoInput_1 = require("./components/selects/YesNoInput");
const SingleSelectInput_1 = require("./components/selects/SingleSelectInput");
const MultipleSelectInput_1 = require("./components/selects/MultipleSelectInput");
const StarRatingInput_1 = require("./components/StarRatingInput");
const inputs_1 = require("../../services/inputs");
const react_i18next_1 = require("react-i18next");
const RedirectionSelectInput_1 = require("./components/selects/RedirectionSelectInput");
const dynamic_1 = __importDefault(require("next/dynamic"));
const ShareButton_1 = require("./components/buttons/ShareButton");
const NumberInput_1 = require("./components/text/NumberInput");
const DateInput_1 = require("./components/text/DateInput");
const ScaleInput_1 = require("./components/ScaleInput");
const PaymentInputElement = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require("./components/text/PaymentInput"))));
const PhoneNumberInput = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require("./components/text/PhoneNumberInput"))));
const LongTextInput = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require("./components/text/LongTextInput"))));
exports.Input = react_1.default.memo(({ type, onSubmit, inputOptions }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13;
    const { t } = (0, react_i18next_1.useTranslation)();
    const stepsDisplayed = (0, store_1.useStoreState)((state) => state.stepsDisplayed.value);
    const chatbot = (0, store_1.useStoreState)((state) => state.chatbot.value);
    const { setQuestionVariableValue } = (0, store_1.useStoreActions)((action) => action.chatbot);
    const currentStepDisplayed = [...stepsDisplayed].pop();
    const handleInputSubmit = (inputValue) => {
        const varIndex = chatbot.variables.questionVariables.findIndex((variable) => variable.stepId === currentStepDisplayed.id);
        let freshQuestionVariables;
        if (varIndex !== -1) {
            setQuestionVariableValue({
                varIndexOrId: varIndex,
                value: inputValue,
            });
            freshQuestionVariables = chatbot.variables.questionVariables;
            freshQuestionVariables[varIndex] = Object.assign(Object.assign({}, freshQuestionVariables[varIndex]), { value: inputValue });
        }
        onSubmit({
            stepIndex: currentStepDisplayed.chatbotStepIndex,
            questionContent: (0, inputs_1.parseQuestionLabel)(currentStepDisplayed, currentStepDisplayed.chatbotStepIndex, chatbot.variables.questionVariables),
            questionType: currentStepDisplayed.answerType,
            value: inputValue,
            questionId: currentStepDisplayed.id,
        }, freshQuestionVariables);
    };
    const handleFormattedInputSubmit = (inputValueFromInput, isRequired) => {
        const inputValue = inputValueFromInput !== null && inputValueFromInput !== void 0 ? inputValueFromInput : "";
        const inputType = currentStepDisplayed.answerType;
        const formattedInput = inputValue.trim();
        const inputIsValid = (0, inputs_1.checkInput)(formattedInput, inputType, isRequired);
        if (inputIsValid) {
            return handleInputSubmit(formattedInput);
        }
        submitRetryAnswer(inputValueFromInput);
    };
    const submitRetryAnswer = (value) => onSubmit({
        isRetry: true,
        stepIndex: currentStepDisplayed.chatbotStepIndex,
        questionContent: (0, inputs_1.parseQuestionLabel)(currentStepDisplayed, currentStepDisplayed.chatbotStepIndex, chatbot.variables.questionVariables),
        questionType: currentStepDisplayed.answerType,
        value,
        questionId: currentStepDisplayed.id,
    });
    switch (type) {
        case __1.InputType.SHORT_TEXT: {
            const options = inputOptions;
            return (react_1.default.createElement(TextInput_1.TextInput, { onSubmit: handleInputSubmit, placeholder: (_b = (_a = options === null || options === void 0 ? void 0 : options.labels) === null || _a === void 0 ? void 0 : _a.placeholder) !== null && _b !== void 0 ? _b : t("Type your answer"), buttonLabel: (_d = (_c = options === null || options === void 0 ? void 0 : options.labels) === null || _c === void 0 ? void 0 : _c.button) !== null && _d !== void 0 ? _d : t("Send"), isRequired: (_e = options === null || options === void 0 ? void 0 : options.isRequired) !== null && _e !== void 0 ? _e : true }));
        }
        case __1.InputType.LONG_TEXT: {
            const options = inputOptions;
            return (react_1.default.createElement(LongTextInput, { onSubmit: handleInputSubmit, placeholder: (_g = (_f = options === null || options === void 0 ? void 0 : options.labels) === null || _f === void 0 ? void 0 : _f.placeholder) !== null && _g !== void 0 ? _g : t("Type your answer"), buttonLabel: (_j = (_h = options === null || options === void 0 ? void 0 : options.labels) === null || _h === void 0 ? void 0 : _h.button) !== null && _j !== void 0 ? _j : t("Send"), isRequired: (_k = options === null || options === void 0 ? void 0 : options.isRequired) !== null && _k !== void 0 ? _k : true }));
        }
        case __1.InputType.NUMBER: {
            const options = inputOptions;
            return (react_1.default.createElement(NumberInput_1.NumberInput, { onSubmit: handleInputSubmit, placeholder: (_m = (_l = options === null || options === void 0 ? void 0 : options.labels) === null || _l === void 0 ? void 0 : _l.placeholder) !== null && _m !== void 0 ? _m : t("type-your-number"), buttonLabel: (_p = (_o = options === null || options === void 0 ? void 0 : options.labels) === null || _o === void 0 ? void 0 : _o.button) !== null && _p !== void 0 ? _p : t("Send"), inputParams: {
                    min: options === null || options === void 0 ? void 0 : options.min,
                    max: options === null || options === void 0 ? void 0 : options.max,
                    step: options === null || options === void 0 ? void 0 : options.step,
                }, isRequired: (_q = options === null || options === void 0 ? void 0 : options.isRequired) !== null && _q !== void 0 ? _q : true }));
        }
        case __1.InputType.YES_OR_NO: {
            return react_1.default.createElement(YesNoInput_1.YesNoInput, { onItemClick: handleInputSubmit });
        }
        case __1.InputType.SINGLE_SELECT: {
            const options = inputOptions;
            return (react_1.default.createElement(SingleSelectInput_1.SingleSelectInput, { items: options.items.map((item) => item.value), onItemClick: handleInputSubmit }));
        }
        case __1.InputType.MULTIPLE_SELECT: {
            const options = inputOptions;
            return (react_1.default.createElement(MultipleSelectInput_1.MultipleSelectInput, { items: options.items.map((item) => item.value), onSubmit: handleInputSubmit, buttonLabel: (_s = (_r = options === null || options === void 0 ? void 0 : options.labels) === null || _r === void 0 ? void 0 : _r.button) !== null && _s !== void 0 ? _s : t("Send") }));
        }
        case __1.InputType.REDIRECTION: {
            const options = inputOptions;
            return (react_1.default.createElement(RedirectionSelectInput_1.RedirectionSelectInput, { items: options.items, onSubmit: handleInputSubmit }));
        }
        case __1.InputType.RATING: {
            const options = inputOptions;
            return (react_1.default.createElement(StarRatingInput_1.StarRatingInput, { onSubmit: handleInputSubmit, buttonLabel: (_u = (_t = options === null || options === void 0 ? void 0 : options.labels) === null || _t === void 0 ? void 0 : _t.button) !== null && _u !== void 0 ? _u : t("Send"), options: options }));
        }
        case __1.InputType.SCALE: {
            const options = inputOptions;
            return react_1.default.createElement(ScaleInput_1.ScaleInput, { onSubmit: handleInputSubmit, options: options });
        }
        case __1.InputType.EMAIL: {
            const options = inputOptions;
            const isRequired = (_v = options === null || options === void 0 ? void 0 : options.isRequired) !== null && _v !== void 0 ? _v : true;
            return (react_1.default.createElement(TextInput_1.TextInput, { onSubmit: (val) => handleFormattedInputSubmit(val, isRequired), placeholder: (_x = (_w = options === null || options === void 0 ? void 0 : options.labels) === null || _w === void 0 ? void 0 : _w.placeholder) !== null && _x !== void 0 ? _x : "email@gmail.com", buttonLabel: (_z = (_y = options === null || options === void 0 ? void 0 : options.labels) === null || _y === void 0 ? void 0 : _y.button) !== null && _z !== void 0 ? _z : t("Send"), autoComplete: "on", type: "email", isRequired: isRequired }));
        }
        case __1.InputType.PHONE: {
            const options = inputOptions;
            const isRequired = (_0 = options === null || options === void 0 ? void 0 : options.isRequired) !== null && _0 !== void 0 ? _0 : true;
            return (react_1.default.createElement(PhoneNumberInput, { language: (_1 = chatbot === null || chatbot === void 0 ? void 0 : chatbot.language) !== null && _1 !== void 0 ? _1 : "en", placeholder: (_3 = (_2 = options === null || options === void 0 ? void 0 : options.labels) === null || _2 === void 0 ? void 0 : _2.placeholder) !== null && _3 !== void 0 ? _3 : t("Phone number"), buttonLabel: (_5 = (_4 = options === null || options === void 0 ? void 0 : options.labels) === null || _4 === void 0 ? void 0 : _4.button) !== null && _5 !== void 0 ? _5 : t("Send"), onSubmit: (val) => handleFormattedInputSubmit(val, isRequired), options: options, isRequired: isRequired }));
        }
        case __1.InputType.WEBSITE: {
            const options = inputOptions;
            const isRequired = (_6 = options === null || options === void 0 ? void 0 : options.isRequired) !== null && _6 !== void 0 ? _6 : true;
            return (react_1.default.createElement(TextInput_1.TextInput, { onSubmit: (val) => handleFormattedInputSubmit(val, isRequired), placeholder: (_8 = (_7 = options === null || options === void 0 ? void 0 : options.labels) === null || _7 === void 0 ? void 0 : _7.placeholder) !== null && _8 !== void 0 ? _8 : t("My url"), buttonLabel: (_10 = (_9 = options === null || options === void 0 ? void 0 : options.labels) === null || _9 === void 0 ? void 0 : _9.button) !== null && _10 !== void 0 ? _10 : t("Send"), type: "url", isRequired: isRequired }));
        }
        case __1.InputType.PAYMENT: {
            const options = inputOptions;
            if (!options)
                throw new Error("input options not found");
            let credentials;
            if ("credentialsId" in options) {
                credentials = (_11 = chatbot.credentials) === null || _11 === void 0 ? void 0 : _11.find((creds) => creds.id === options.credentialsId);
            }
            return (react_1.default.createElement(PaymentInputElement, { stepIndex: currentStepDisplayed.chatbotStepIndex, onSubmit: (errorCode) => {
                    if (errorCode)
                        return submitRetryAnswer(errorCode);
                    return handleInputSubmit(t("success"));
                }, options: credentials !== null && credentials !== void 0 ? credentials : options, buttonLabel: (_13 = (_12 = options === null || options === void 0 ? void 0 : options.labels) === null || _12 === void 0 ? void 0 : _12.button) !== null && _13 !== void 0 ? _13 : t("Send") }));
        }
        case __1.InputType.DATE_PICKER: {
            const options = inputOptions;
            return react_1.default.createElement(DateInput_1.DateInput, Object.assign({ onSubmit: handleInputSubmit }, options));
        }
        case __1.InputType.SHARE: {
            return react_1.default.createElement(ShareButton_1.ShareButtons, null);
        }
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
});
//# sourceMappingURL=index.js.map